import { createRoot } from "react-dom/client";
import "./index.css";
import LocalLlmSection from "./App.jsx";

function initLocalLlmSection() {
  const container = document.getElementById("local-llm-root");
  if (container) {
    const root = createRoot(container);
    root.render(<LocalLlmSection />);
  } else {
    console.warn("Local LLM section container #local-llm-root not found");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLocalLlmSection);
} else {
  initLocalLlmSection();
}
